import BackIcon from '@mui/icons-material/ArrowLeftOutlined';
import { alpha, Box, Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const PREFIX = 'HistoryButtons';

const classes = {
  icon: `${PREFIX}-icon`,
  box: `${PREFIX}-box`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.icon}`]: { color: theme.palette.primary.contrastText },

  [`& .${classes.box}`]: {
    color: alpha(theme.palette.primary.contrastText, 0.8),
    textDecoration: 'none',
    cursor: 'pointer'
  }
}));

interface HistoryButtonsProps {
  onloginVisible?: boolean;
}

export default function HistoryButtons({ onloginVisible }: HistoryButtonsProps): JSX.Element {
  const parsePeriod = (search: string) => {
    let period = '';
    if (search.includes('&period=') || search.includes('?period=')) {
      const idxPeriod: number = search.includes('&period=')
        ? search.indexOf('&period=')
        : search.indexOf('?period=');
      period = search.substring(idxPeriod + 1);
      if (period.includes('&')) period = period.substring(0, period.indexOf('&'));
    }
    return period;
  };

  const replacePeriod = (search: string, newPeriod: string) => {
    return search.replace(parsePeriod(search), newPeriod);
  };

  const history = useHistory();

  const { pathname, search } = useLocation();
  const [usedPeriod, setUsedPeriod] = useState<string>(parsePeriod(search));
  const [pushedLocations, setPushedLocations] = useState<
    { pathname: string; search: string; title?: string }[]
  >([{ pathname, search, title: history.location.state?.fromTitle || null }]);

  useEffect(() => {
    history.listen(() => {
      // if (history.action === 'PUSH' || history.action === 'REPLACE') {
      if (history.action === 'PUSH') {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { pathname, search } = history.location;
        const period = parsePeriod(search);
        if (period) setUsedPeriod(period);
        if (
          !pushedLocations.length ||
          pushedLocations[pushedLocations.length - 1].pathname !== pathname ||
          replacePeriod(pushedLocations[pushedLocations.length - 1].search, period) !== search
        )
          setPushedLocations(
            pushedLocations.concat([
              { title: history.location.state?.fromTitle || null, ...history.location }
            ])
          );
      }
    });
  }, [pushedLocations]);

  function handleClickBack(): void {
    let locs: React.SetStateAction<{ pathname: string; search: string }[]> = [];
    if (pushedLocations.length > 1) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const { pathname, search } = pushedLocations[pushedLocations.length - 2];
      history.replace({ pathname, search: replacePeriod(search, usedPeriod) });
      locs = pushedLocations.slice(0, pushedLocations.length - 1);
    }
    setPushedLocations(locs);
  }

  return (
    <Root>
      {(onloginVisible ||
        (pushedLocations && pushedLocations[pushedLocations.length - 1]?.title)) && (
        <Box
          sx={{ bgcolor: 'primary.main', border: 0 }}
          component="button"
          display="flex"
          onClick={handleClickBack}
          className={classes.box}
        >
          <Grid container wrap="nowrap" alignItems="center" spacing={0}>
            <Grid item>
              <IconButton
                color="inherit"
                className={classes.icon}
                data-testid="history-back-button"
                size="large"
              >
                <BackIcon />
              </IconButton>
            </Grid>
            <Grid item xs zeroMinWidth>
              <Typography variant="h6" noWrap data-testid="history-back-title">
                {`${
                  pushedLocations[pushedLocations.length - 1]?.title
                    ? pushedLocations[pushedLocations.length - 1].title
                    : 'LEVEL UP'
                }`}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </Root>
  );
}
